import api from './apiClient';
import { Plan, Subscription } from './planApi';
import type { ApiResponse } from 'shared/types/api';

export interface BillingInvoiceLite {
  _id: string;
  amount: number;
  currency: string;
  status: 'draft' | 'issued' | 'paid' | 'overdue' | 'void' | 'error';
  periodStart: string;
  periodEnd: string;
  billingCycle: 'monthly' | 'yearly';
  alegraInvoiceId?: string;
  alegraNumber?: string;
  alegraPdfUrl?: string;
  createdAt: string;
}

export interface WalkthroughStatus {
  subscription: Pick<Subscription, '_id' | 'status' | 'billingCycle' | 'plan'> & {
    company: { _id: string; name: string };
  };
  latestInvoice: BillingInvoiceLite | null;
  plans: Plan[];
  needsWalkthrough: boolean;
}

export interface NeedsWalkthrough {
  needs: boolean;
  status?: string;
}

export const walkthroughApi = {
  status: async (): Promise<WalkthroughStatus> => {
    const res = await api.get<ApiResponse<WalkthroughStatus>>('/walkthrough/status');
    return res.data!;
  },
  needs: async (): Promise<NeedsWalkthrough> => {
    const res = await api.get<ApiResponse<NeedsWalkthrough>>('/walkthrough/needs');
    return res.data!;
  },
  selectPlan: async (data: { planId: string; billingCycle: 'monthly' | 'yearly' }): Promise<{ subscription: Subscription }> => {
    const res = await api.post<ApiResponse<{ subscription: Subscription }>>('/walkthrough/select-plan', data);
    return res.data!;
  },
  simulateCardPayment: async (data: { last4?: string; brand?: string; holder?: string }): Promise<{ subscription: Subscription; invoice: BillingInvoiceLite }> => {
    const res = await api.post<ApiResponse<{ subscription: Subscription; invoice: BillingInvoiceLite }>>('/walkthrough/simulate-card-payment', data);
    return res.data!;
  },
  manualClaim: async (data: { method: 'transfer' | 'sinpe'; reference?: string; note?: string }): Promise<{ subscription: Subscription; invoice: BillingInvoiceLite; message: string }> => {
    const res = await api.post<ApiResponse<{ subscription: Subscription; invoice: BillingInvoiceLite; message: string }>>('/walkthrough/manual-claim', data);
    return res.data!;
  },
};
